import 'css-chunksrc/client/pages/projectPage/synthesisPage/section/styles.scss';export default {
  "section": "_section_1oz8s_1",
  "heading": "_heading_1oz8s_11",
  "title": "_title_1oz8s_19",
  "main": "_main_1oz8s_25",
  "iconBox": "_iconBox_1oz8s_31",
  "icon": "_icon_1oz8s_31"
};